import api from "../util/api";

const API_BASE = "/admin";






const request = async (url, options = {}) => {
    let response;

    const config = {
        headers: {
            ...(options.headers || {}),
        },
    };

    if (options.method === "GET") {
        response = await api.get(
            `${API_BASE}${url}`,
            config
        );
    }

    if (options.method === "POST") {
        response = await api.post(
            `${API_BASE}${url}`,
            options.body,
            config
        );
    }

    if (options.method === "PUT") {
        response = await api.put(
            `${API_BASE}${url}`,
            options.body,
            config
        );
    }

    if (options.method === "DELETE") {
        response = await api.delete(
            `${API_BASE}${url}`,
            config
        );
    }

    if (options.method === "PATCH") {
        response = await api.patch(
            `${API_BASE}${url}`,
            options.body,
            config
        );
    }

    const result = response.data;

    if (result.success === false) {
        throw new Error(
            result.message || "Request failed."
        );
    }

    return result;
};


export const getDashboard = async () => {
    return request("/dashboard", { method: "GET" });
};

export const getActivities = async (
    page = 1,
    perPage = 20,
    filters = {}
) => {

    const params = new URLSearchParams();

    params.set("page", page);
    params.set("per_page", perPage);

    if (filters.search) {
        params.set("search", filters.search);
    }

    if (filters.action) {
        params.set("action", filters.action);
    }

    return request(
        `/activity?${params.toString()}`  , { method: "GET" }
    );
};

export const getAdminUsers = async (
    page = 1,
    perPage = 10,
    filters = {}
) => {

    const params =
        new URLSearchParams();

    params.set("page", page);
    params.set("per_page", perPage);

    if (filters.search) {
        params.set(
            "search",
            filters.search
        );
    }

    if (filters.role) {
        params.set(
            "role",
            filters.role
        );
    }

    if (
        filters.active !== undefined &&
        filters.active !== ""
    ) {
        params.set(
            "active",
            filters.active
        );
    }

    return request(
        `/users?${params.toString()}`,

        { method: "GET" }

    );
};


export const createAdminUser = async (
    data
) => {
    return request("/users", {
        method: "POST",
        body: JSON.stringify(data),
    });
};


export const updateAdminUser = async (
    id,
    data
) => {
    return request(`/users/${id}`, {
        method: "PUT",
        body: JSON.stringify(data),
    });
};


export const toggleAdminUser = async (
    id
) => {
    return request(
        `/users/${id}/active`,
        {
            method: "PATCH",
        }
    );
};


export const deleteAdminUser = async (
    id
) => {
    return request(
        `/users/${id}`,
        {
            method: "DELETE",
        }
    );
};


export const getSiteSettings = async () => {
    return request("/settings", { method: "GET" });
};


export const updateSiteSettings = async (
    data
) => {

    return request("/settings", {
        method: "POST",
        body: data,

            headers: {
                            "Content-Type":
                                "multipart/form-data"
                        },


        
        

    });
};




/* new */

export const getLegislativeItems = async (
    page = 1,
    perPage = 10,
    filters = {}
) => {
    const params = new URLSearchParams();

    params.set("page", page);
    params.set("per_page", perPage);

    if (filters.search) {
        params.set("search", filters.search);
    }

    if (filters.featured !== undefined && filters.featured !== "") {
        params.set("featured", filters.featured);
    }

    if (filters.active !== undefined && filters.active !== "") {
        params.set("active", filters.active);
    }

    return request(`/legislative?${params.toString()}`, {method: "GET"});
};

export const getLegislativeItem = async (id) => {
    return request(`/legislative/${id}`, {method: "GET"});
};

export const createLegislativeItem = async (data) => {
   alert(JSON.stringify(data));


 let response = await  request("/legislative", {
        method: "POST",
        body: data,
       
    })

     

    return response ;

    
};

export const updateLegislativeItem = async (id, data) => {
    return request(`/legislative/${id}`, {
        method: "PUT",
        body: JSON.stringify(data),
       
    });
};




export const toggleLegislativeFeatured = async (id) => {
    return request(`/legislative/${id}/featured`, {
        method: "PATCH",
    });
};

export const toggleLegislativeActive = async (id) => {
    return request(`/legislative/${id}/active`, {
        method: "PATCH",
    });
};

export const deleteLegislativeItem = async (id) => {
    return request(`/legislative/${id}`, {
        method: "DELETE",
    });
};